import React from 'react';
import styles from './Header.module.css';

const Header = ({ onBuyClick }) => {
  const handleBuyClick = () => {
    if (onBuyClick) {
      onBuyClick();
    } else {
      // Fallback: скролл к pricing
      const pricingSection = document.querySelector('[data-section="pricing"]');
      if (pricingSection) {
        pricingSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <header className={styles.header}>
      <nav className={styles.nav}>
        <a href="/" className={styles.logo}>Прогноз по 9 Дворцам</a>
        <button className="gamify-btn" onClick={handleBuyClick}>
          КУПИТЬ <span className={styles.arrow}></span>
        </button>
      </nav>
    </header>
  );
};

export default Header;

